<div class="table-page table-page--fill">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" aria-label="بازگشت"
        [routerLink]="['/carInfo', mdlTempAccess.get('strUnitID')?.value]">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <div class="title-block">
        <h1 class="title">دسترسی‌های موقت</h1>
      </div>
      <div class="actions">
        <button class="btn-round btn-round-primary" type="button" [disabled]="loading"
          aria-label="افزودن دسترسی موقت" (click)="tooltip.hide(); openModal(false)"
          (mouseenter)="tooltip.show($event, 'افزودن دسترسی موقت')" (mouseleave)="tooltip.hide()"
          (focus)="tooltip.show($event, 'افزودن دسترسی موقت')" (blur)="tooltip.hide()">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </header>

  <section class="card" aria-label="فهرست دسترسی‌های موقت">
    <div class="table-toolbar">
      <div class="search-wrap">
        <input class="control" type="search" aria-label="جستجو در دسترسی‌های موقت"
          placeholder="جستجو در جدول: ایجادکننده، موبایل، تاریخ شروع و پایان..."
          [disabled]="loading" [(ngModel)]="searchText" (ngModelChange)="refreshTable(true)" />
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
    </div>

    <div class="body" [attr.aria-busy]="loading">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite">
        <div class="spinner"></div>
        <span>در حال دریافت اطلاعات…</span>
      </div>
      <div class="state" id="stEmpty" [class.show]="!loading && !hasError && list_Result.length === 0">
        <div class="ico-big"><i class="fa fa-inbox" aria-hidden="true"></i></div>
        <h4>{{ searchText.trim() ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'هنوز دسترسی موقتی ثبت نشده است' }}</h4>
        <span class="muted">{{ searchText.trim() ? 'عبارت جستجو را تغییر دهید و دوباره تلاش کنید.' : 'برای ایجاد دسترسی موقت، از دکمهٔ افزودن استفاده کنید.' }}</span>
        <div class="empty-actions" *ngIf="searchText.trim()">
          <button class="btn btn-ghost" type="button" (click)="searchText = ''; refreshTable(true)">
            <i class="fa fa-undo" aria-hidden="true"></i> حذف جستجو
          </button>
        </div>
      </div>
      <div class="state error" id="stError" [class.show]="!loading && hasError" role="alert">
        <div class="ico-big"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <h4>دریافت اطلاعات با خطا مواجه شد</h4>
        <span class="muted">دوباره تلاش کنید.</span>
        <button class="btn btn-primary retry" type="button" (click)="getTempAccess()">
          <i class="fa fa-refresh" aria-hidden="true"></i> تلاش مجدد
        </button>
      </div>

      <div class="table-scroll" id="tableWrap" (scroll)="tooltip.hide()">
        <table aria-label="دسترسی‌های موقت">
          <thead id="thead">
            <tr>
              <th class="col-ops sticky-first">عملیات</th>
              <th class="col-num">ردیف</th>
              <th>زمان ایجاد</th>
              <th>ایجادکننده</th>
              <th>موبایل (کاربری)</th>
              <th>تاریخ شروع</th>
              <th>ساعت شروع</th>
              <th>تاریخ پایان</th>
              <th>ساعت پایان</th>
              <th>آخرین استفاده</th>
            </tr>
          </thead>
          <tbody id="tbody">
            <tr *ngFor="let item of pagedRows; let i = index; trackBy: trackByAccess">
              <td class="col-ops sticky-first">
                <div class="row-ops">
                  <button class="ico" type="button" aria-label="ویرایش" [disabled]="loading"
                    (click)="tooltip.hide(); openModal(true, item)"
                    (mouseenter)="tooltip.show($event, 'ویرایش')" (mouseleave)="tooltip.hide()"
                    (focus)="tooltip.show($event, 'ویرایش')" (blur)="tooltip.hide()">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button class="ico" type="button" aria-label="پیامک لینک به موبایل کاربر" [disabled]="loading"
                    (click)="tooltip.hide(); openSmsModal(item)"
                    (mouseenter)="tooltip.show($event, 'پیامک لینک به موبایل کاربر')" (mouseleave)="tooltip.hide()"
                    (focus)="tooltip.show($event, 'پیامک لینک به موبایل کاربر')" (blur)="tooltip.hide()">
                    <i class="fa fa-envelope-o" aria-hidden="true"></i>
                  </button>
                  <button class="ico" type="button" aria-label="حذف" [disabled]="loading"
                    (click)="tooltip.hide(); remove_TempAccess(item)"
                    (mouseenter)="tooltip.show($event, 'حذف')" (mouseleave)="tooltip.hide()"
                    (focus)="tooltip.show($event, 'حذف')" (blur)="tooltip.hide()">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="col-num">{{ (currentPage - 1) * pageSize + i + 1 | faNum }}</td>
              <td>{{ item.strFullDate | faNum }}</td>
              <td>{{ item.strFullName | faNum }}</td>
              <td>{{ item.strMobile | faNum }}</td>
              <td>{{ item.strSDate | faNum }}</td>
              <td>{{ item.strSTime | faNum }}</td>
              <td>{{ item.strEDate | faNum }}</td>
              <td>{{ item.strETime | faNum }}</td>
              <td>{{ item.strLastUssFullDate | faNum }}</td>
            </tr>
          </tbody>
          <tfoot *ngIf="!loading && !hasError && list_Result.length">
            <tr>
              <td class="sticky-first"></td>
              <td class="label" colspan="9">تعداد کل: {{ list_Result.length | number | faNum }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="list_Result.length"
      (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)">
    </app-table-pagination>
  </section>
  <app-table-tooltip #tooltip></app-table-tooltip>
</div>

<!-- افزودن -->

<div class="modal fade" id="tempAccess-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> {{ bEditMode ? 'ویرایش' : 'افزودن' }} دسترسی موقت </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body">

            <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">تاریخ شروع</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                         <input dir="ltr" type="text" formControlName="strSDate" class="form-control" >
                        
                    </ng-persian-datepicker>

                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">ساعت شروع</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="Stime" formControlName="strSTime">
                        
                        <span class="input-group-addon ">
                            
                            <span class="glyphicon glyphicon-time"></span>
                            
                        </span>
                        
                    </div>
                    
                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">تاریخ پایان</label>

                    <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                        <input dir="ltr" type="text" formControlName="strEDate" class="form-control" >
                       
                   </ng-persian-datepicker>

                </div>

                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">ساعت پایان</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control text-center" id="Etime" formControlName="strETime">
                        
                        <span class="input-group-addon ">
                            
                            <span class="glyphicon glyphicon-time"></span>
                            
                        </span>
                        
                    </div>

                </div>
                
                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">موبایل (کاربری)</label>

                    <input dir="ltr" type="text" maxlength="11" formControlName="strMobile" class="form-control" >

                </div>
                
                <div class="position-relative col-md-6 col-12">

                    <label for="strFamily" class="text-danger">رمز عبور</label>

                    <input dir="ltr" type="text" formControlName="strPassword" class="form-control" >

                </div>

            </div>

        </div>

        <div class="modal-footer">

            <div class="col-12 d-flex justify-content-end">

                <button class="btn px-4" [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' " (click)="new_TempAccess()">

                    {{bEditMode ? 'ویرایش' : 'ذخیره' }}

                </button>

            </div>

        </div>
  
      </div>
  
    </div>
  
</div>

<!-- ارسال SMS -->

<div class="modal fade" id="tempSMS-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-md">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> پیامک لینک به موبایل کاربر  </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <div class="modal-body">

            <div [formGroup]="mdlTempAccess" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">

                <div class="position-relative col-12">

                    <label for="strFamily" class="text-danger">شماره موبایل کاربر</label>

                    <input dir="ltr" type="text" maxlength="11" 
                    
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    
                        formControlName="strMobile" class="form-control" >

                </div>
                
            </div>

        </div>

        <div class="modal-footer">

            <div class="col-12 d-flex justify-content-end">

                <button class="btn btn-danger px-4" data-bs-dismiss="modal" aria-label="Close">

                    لغو

                </button>

                <button class="btn btn-success px-4 mx-2" (click)="send_SMS()">

                    ارسال

                </button>

            </div>

        </div>
  
      </div>
  
    </div>
  
</div>
